export default function hasErrors(collectionType, id, state) {
  const key = `${collectionType}/${id}`;

  const firstError = state.error.find(r => r.id === key);

  return firstError ? firstError.error : null;
}
